export default {
    methods: {
        subscribeRowClickMutation() {
            if (typeof this.options.rowClickCallback === 'function') {
                this.$store.subscribe((mutation, state) => {
                    if (mutation.type == `${this.name}/ROW_CLICK`) {
                        const payload = mutation.payload;

                        if (this.allowClickEvent(payload.event)) {
                            this.options.rowClickCallback(
                                payload.row,
                                payload.event,
                            );
                        }
                    }
                });
            }
        },

        /**
         * @param  {Object}
         * @return {Boolean}
         */
        allowClickEvent(e) {
            const className = e.target.className;
            const type = e.target.type;
            const elem = $(e.target);
            const hasPreventClick =
                elem.parents('.prevent-click').length ||
                elem.hasClass('prevent-click');

            if (
                className == 'indigo' ||
                elem.has('input[type=checkbox]').length > 0 ||
                type == 'checkbox' ||
                hasPreventClick
            ) {
                return false;
            }

            return true;
        },
    },

    mounted() {
        this.subscribeRowClickMutation();
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/mixins/row-click.js